import { useState, useEffect } from "react";
import Markdown from "markdown-to-jsx";
import Modal from "../Modal/Modal";
import { Tabs, Tab } from "@mui/material";
import classes from "./BaseResponseModal.module.css";

export default function BaseResponsesModal({ open, title, content, onClose, tabs, globalContent }) {
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    if (open) setActiveTab(0);
  }, [open]);

  return (
    <Modal open={open} handleClose={onClose} title={title} width={800}>
      {tabs && tabs.length > 0 ? (
        <div className={classes.info_modal_content}>
          {globalContent && (
            <div style={{ borderBottom: "1px solid #e0e0e0", marginBottom: 8, paddingBottom: 8 }}>
              <Markdown>{globalContent}</Markdown>
            </div>
          )}
          <Tabs
            value={activeTab}
            onChange={(_, v) => setActiveTab(v)}
            variant="scrollable"
            scrollButtons="auto"
            sx={{ borderBottom: 1, borderColor: "divider", mb: 1, position: "sticky", top: 0, background: "#fff", zIndex: 1 }}
          >
            {tabs.map((tab, i) => (
              <Tab key={i} label={tab.label} />
            ))}
          </Tabs>
          <Markdown>{tabs[activeTab]?.content || ""}</Markdown>
        </div>
      ) : (
        <div className={classes.info_modal_content}>
          <Markdown>{content || ""}</Markdown>
        </div>
      )}
    </Modal>
  );
}
